module.exports = __webpack_public_path__ + "img/wrong.6a24e39a.png";